import React from "react";
import classes from "./NavItem.module.css";
import { NavLink } from "react-router-dom";

function NavItem(props) {
  return (
    <li className={classes.NavItem}>
      <NavLink className={classes.NavItemLink} to={props.link}>
        {props.children}
      </NavLink>
    </li>
  );
}

export default NavItem;
